//
const USER_REPLIES = [
  {
    id: 1,
    alternatives: ["Lab KEX: Pokémon"],
  },
  {
    id: 2,
    alternatives: [
      "Task 1.1",
      "Task 1.2",
      "Task 1.3",
      "Task 1.4",
      "Task 1.5",
      "Task 1.6",
    ],
  },
];

// Queries that Dogge asks
const QUERIES = [
  {
    id: 1,
    query:
      "Hi there student! My name is Dogge and I am your personal virtual assistant! What do you need help with this session?",
  },
  {
    id: 2,
    query: "Ok, let's look into it! What task are you currently stuck on?",
  },
];

// 3-dimensional array with results responses
const RESULTS = [
  [
    {
      // Alternative: 1 - 1
      id: 1,
      query: `All right! So this task regards classes in Python. Namely the creation of the class and the initiation of its first instance!
              Here are some helpful links to help you on your way!`,
      links: [
        {
          label: "Classes & Objects",
          url: "https://www.w3schools.com/python/python_classes.asp",
          thumbnail: "https://i.ibb.co/zGXx8y4/Thumb-1.png",
          publisher: "W3schools.com",
        },
        {
          label: "The '__lt__' Method",
          url: "https://www.geeksforgeeks.org/python-__lt__-magic-method/",
          thumbnail: "https://i.ibb.co/MphpXQc/Thumb-2.png",
          publisher: "GeeksForGeeks.org",
        },
      ],
    },
    {
      // Alternative: 1 - 2
      id: 2,
      query:
        "Great! In this task you should create a function that initiates a Pokemon object! The link below has some examples of object initiation!",
      links: [
        {
          label: "Classes & Objects",
          url: "https://www.w3schools.com/python/python_classes.asp",
          thumbnail: "https://i.ibb.co/zGXx8y4/Thumb-1.png",
          publisher: "W3schools.com",
        },
      ],
    },
    {
      // Alternative: 1 - 3
      id: 3,
      query:
        "Let's get to it! This task asks you to read from a file, and from that data create pokemon objects! Below are some links on file reading! Other useful functions when reading from a file are split() and strip()!",
      links: [
        {
          label: "File Reading",
          url: "https://www.w3schools.com/python/python_file_open.asp",
          thumbnail: "https://i.ibb.co/zmWNkSZ/Thumb-3.png",
          publisher: "W3schools.com",
        },
        {
          label: "Split() Function",
          url: "https://www.w3schools.com/python/ref_string_split.asp",
          thumbnail: "https://i.ibb.co/yWZW5cp/Thumb-5.png",
          publisher: "W3schools.com",
        },
        {
          label: "Strip() Function",
          url: "https://www.w3schools.com/python/ref_string_strip.asp",
          thumbnail: "https://i.ibb.co/SdzM6Bc/Thumb-4.png",
          publisher: "W3schools.com",
        },
      ],
    },
    {
      // Alternative: 1 - 4
      id: 4,
      query:
        "Awesome! Instead of reading from a file this task asks you to create/write to a file! Using a for-loop and constructing a string for this works like magic! Below is a link on file writing!",
      links: [
        {
          label: "File Writing",
          url: "https://www.w3schools.com/python/python_file_write.asp",
          thumbnail: "https://i.ibb.co/nsZKFSP/Thumb-6.png",
          publisher: "W3schools.com",
        },
      ],
    },
    {
      // Alternative: 1 - 5
      id: 5,
      query:
        "Almost at the end, good job! Creating a search algorithm can be quite difficult but Python offers excellent tools for this! Using the 'in' operator works great when looking for substrings within a string! Don't forget that Python differentiates between uppercase and lowercase letters, which your algorithm should take into account! Below is a link on the 'in' membership operator!",
      links: [
        {
          label: "The Membership Operator 'in'",
          url: "https://www.geeksforgeeks.org/python-membership-identity-operators-not-not/",
          thumbnail: "https://i.ibb.co/zVJ3tvH/Thumb-7.png",
          publisher: "GeeksForGeeks.org",
        },
      ],
    },
    {
      // Alternative: 1 - 6
      id: 6,
      query:
        "Final task, almost done! There are multiple ways to filter a list, the most simple and intutive being a for-loop with an if-statement, the disadvantage being the code often gets bulky. If you dare however, there are more efficient ways Python has to offer! Take a look at the link below for inspiration!",
      links: [
        {
          label: "Ways of Filtering a List",
          url: "https://favtutor.com/blogs/filter-list-python",
          thumbnail: "https://i.ibb.co/bBCqjHc/Thumb-8.png",
          publisher: "FavTutor.com",
        },
      ],
    },
  ],
];

export { USER_REPLIES, QUERIES, RESULTS };
